import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Plus } from "lucide-react";
import { Reveal, SectionTag } from "./Reveal";

export const FAQS = [
  {
    q: "Which cars do you make parts for?",
    a: "Right now we build for the Nissan 350Z (Z33), including DE models. We're expanding to more JDM platforms — follow @rayce_parts for new releases.",
  },
  {
    q: "Are your parts custom-fit or universal?",
    a: "Every part is CAD-designed for exact factory fitment on a specific chassis — no universal kits and no LHD-only compromises. They drop in like OEM.",
  },
  {
    q: "What are the parts made from?",
    a: "Durable, heat-aware 3D-printing material with a clean matte finish that suits a JDM interior. Every part is test-fitted on a real car before it ships.",
  },
  {
    q: "How much do they cost?",
    a: "The 350Z DE centre console cupholder insert is $80 AUD. The triple gauge pod is priced on enquiry as it's made to your spec. Shipping is confirmed with your quote.",
  },
  {
    q: "Do you ship, and where?",
    a: "Yes — we're based in Brisbane, Australia and ship Australia-wide. Shipping cost is calculated and confirmed with your quote.",
  },
  {
    q: "How do I order?",
    a: "Send an enquiry through the form on this site (or DM @rayce_parts). We'll confirm the spec, price and shipping before anything gets printed.",
  },
];

const Item = ({ item, index, open, onToggle }) => (
  <div
    className="border-b border-white/10"
    data-testid={`faq-item-${index}`}
  >
    <button
      onClick={onToggle}
      className="w-full flex items-center justify-between gap-6 py-6 text-left group"
      data-testid={`faq-toggle-${index}`}
      aria-expanded={open}
    >
      <span className="font-display text-2xl md:text-3xl text-white group-hover:text-[#e31e24] transition-colors">
        {item.q}
      </span>
      <span
        className={`shrink-0 grid place-items-center h-9 w-9 border transition-all duration-300 ${
          open
            ? "border-[#e31e24] bg-[#e31e24] rotate-45"
            : "border-white/20 group-hover:border-[#e31e24]"
        }`}
      >
        <Plus size={18} className="text-white" />
      </span>
    </button>
    <AnimatePresence initial={false}>
      {open && (
        <motion.div
          initial={{ height: 0, opacity: 0 }}
          animate={{ height: "auto", opacity: 1 }}
          exit={{ height: 0, opacity: 0 }}
          transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
          className="overflow-hidden"
        >
          <p className="pb-6 pr-16 text-white/60 text-base leading-relaxed max-w-2xl">
            {item.a}
          </p>
        </motion.div>
      )}
    </AnimatePresence>
  </div>
);

export const FAQ = () => {
  const [open, setOpen] = useState(0);
  return (
    <section
      id="faq"
      className="relative py-24 md:py-36 px-5 md:px-10"
      data-testid="faq-section"
    >
      <div className="mx-auto max-w-[1100px]">
        <div className="mb-12">
          <SectionTag index="05" label="FAQ" />
          <h2 className="font-display text-[clamp(2.6rem,7vw,6rem)] text-white">
            Questions? <span className="text-[#e31e24]">Answered.</span>
          </h2>
        </div>
        <Reveal>
          <div className="border-t border-white/10">
            {FAQS.map((item, i) => (
              <Item
                key={i}
                item={item}
                index={i}
                open={open === i}
                onToggle={() => setOpen(open === i ? -1 : i)}
              />
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
};
